"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _vuex = _interopRequireDefault(require("vuex"));
var _vuexPersistedstate = _interopRequireDefault(require("vuex-persistedstate"));
var _getters = _interopRequireDefault(require("./getters"));
var _app = _interopRequireDefault(require("./modules/app"));
var _biz = _interopRequireDefault(require("./modules/biz"));
var _common = _interopRequireDefault(require("./modules/common"));
var _cron = _interopRequireDefault(require("./modules/cron"));
var _logs = _interopRequireDefault(require("./modules/logs"));
var _modalProcess = _interopRequireDefault(require("./modules/modalProcess"));
var _tags = _interopRequireDefault(require("./modules/tags"));
var _user = _interopRequireDefault(require("./modules/user"));
_vue.default.use(_vuex.default);
var _default = exports.default = new _vuex.default.Store({
  modules: {
    app: _app.default,
    biz: _biz.default,
    user: _user.default,
    common: _common.default,
    logs: _logs.default,
    tags: _tags.default,
    cron: _cron.default,
    modalProcess: _modalProcess.default
  },
  state: {
    loginPath: '/user/login'
  },
  mutations: {},
  actions: {},
  getters: _getters.default,
  plugins: [(0, _vuexPersistedstate.default)({
    reducer({
      user,
      app,
      common,
      logs
    }) {
      return {
        user,
        app,
        common,
        logs
      };
    }
  })]
});